import { Deal } from '../Types/deal';
import { ListInvoice } from '../Types/invoice';

export const canOpenNavigationForDeal = (deal?: Deal): boolean => {
  if (!deal) {
    return false;
  }

  if (deal.quotations.length > 1) {
    return true;
  }

  return false;
};

export const canOpenNavigationForInvoice = (...invoicesGroup: Array<ListInvoice[] | undefined>): boolean => {
  const sum = invoicesGroup.reduce((sum, invoices) => {
    if (!invoices) {
      return sum;
    }

    return sum + invoices.length;
  }, 0);

  return sum > 1;
};
